import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Sent' },
    { value: 2, label: 'Failed' },
    { value: 10, label: 'Received' },
    { value: 11, label: 'Submitted' },
    { value: 12, label: 'Scheduled' },
    { value: 13, label: 'Bounced' },
    { value: 14, label: 'Rejected' },
    { value: 15, label: 'Revoked' },
    { value: 16, label: 'Expired' },
    { value: 17, label: 'Spam' },
    { value: 18, label: 'Unsubscribed' },
  ],
});
